import React from "react";
import { cFormat } from "../utility/util-methods";
import Spinner from "../utility/spinner";
//import MessageBox from "../utility/message-box";
import rq from "../utility/rq.js";
import update from 'immutability-helper';


export default class CurrencyEntry extends React.Component {
    constructor() {
        super();
        this.state = {
            currencyData: null,
            showSpinner: false

        };
        this.messageBox = null;
        this.focusSet = false;
    }
    calculateIn(currency, index, e) {
        if ((parseInt(e.target.value, 10) > 0)) {
            let currencyData = update(this.state.currencyData, { [index]: { in: { $set: parseInt(e.target.value, 10) } } });
            this.setState({ currencyData });
        } else {
            let currencyData = update(this.state.currencyData, { [index]: { in: { $set: 0 } } });
            this.setState({ currencyData });
        }


    }

    calculateOut(currency, index, e) {
        var out = parseInt(e.target.value, 10) > 0 ? parseInt(e.target.value, 10) : 0;
        if (out > 0 && out <= currency.available) {
            let currencyData = update(this.state.currencyData, { [index]: { out: { $set: parseInt(e.target.value, 10) } } });
            this.setState({ currencyData });
        } else {
            let currencyData = update(this.state.currencyData, { [index]: { out: { $set: 0 } } });
            e.target.value = "";
            this.setState({ currencyData });
        }

    }

    getTotal(type) {
        let total = 0;
        for (var i = 0; i < this.state.currencyData.length; i++) {
            total += this.state.currencyData[i].denominationName * this.state.currencyData[i][type];
        }
        return total;
    }

    componentWillMount() {
        if (typeof this.props.onSave !== "function")
            throw new Error("Currency Entry need a onSave call back");
        if (typeof this.props.visible !== "boolean")
            throw new Error("Currency Entry form needs a visible property that must be a boolean");
        if (typeof this.props.onCancel !== "function")
            throw new Error("Currency Entry form needs a visible property that must be a boolean");
    }


    onSaveClick() {
        // this.props.onSave(this.state.availableCurrencies, this.getAvailableTotal(), this.state.curencies, this.getTotal("in"), this.getTotal("out"));
        this.props.onSave(this.state.currencyData, this.getTotal("in"), this.getTotal("out"));
    }


    onCancel() {
        this.props.onCancel();
    }

    handleEnter(e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            this.onSaveClick();
        }
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.reset) {
            this.setState({
                currencyData: null,
                showSpinner: false
            });
            return;
        }

        // console.log(">>>>>>>>>>>", nextProps);
        if (nextProps.visible) {
            this.setFocus = undefined;
            this.setState({ showSpinner: true });
            // make rq call to get available currency Data

            rq.getJsonData(nextProps.url || "/api/v1/availablecurrency").then((data) => {
                //console.log(this.refs.tableIn);
                this.setState({ currencyData: data, showSpinner: false });
            }).catch((err) => {
                alert("fethching currency availability failed");
                this.props.onFailed ? this.props.onFailed() : "";
                this.setState({ showSpinner: false });
                throw err;
            });

        }
    }

    componentDidUpdate() {
        // console.log("update fired", this.setFocus);
        if (this.setFocus === undefined) {
            if (this.refs.tableIn) {
                if (this.props.focus === "in") {
                    this.refs.tableIn.children[0].children[0].children[1].children[0].focus();
                    this.setFocus = true;
                }
                else if (this.props.focus === "out") {
                    this.refs.tableOut.children[0].children[0].children[1].children[0].focus();
                    this.setFocus = true;
                }
            }
        }

    }



    render() {
        //console.log("avalabe currencies", this.props.visible);
        return (
            <div>
                {this.state.currencyData ?
                    <div className="currencyForm" style={{ display: this.props.visible ? "block" : "none" }} onKeyDown={this.handleEnter.bind(this)}>

                        <div className="cBox" style={{ float: "left" }} >
                            <p className="cLabel">Available</p>
                            <table className="cTable" >
                                <tbody>
                                    {this.state.currencyData.map((currency, i) => {

                                        return (
                                            <tr key={i}>
                                                <td>
                                                    <span style={{ background: "#c18fb7" }} className="cCurrency">{currency.denominationName > 500 ? currency.denominationName.toString()[0] + "K" : currency.denominationName}</span>
                                                </td>
                                                <td>
                                                    <input type="text" className="cInput" value={currency.available} disabled={true} />
                                                </td>
                                                <td className="rCurrency">{cFormat(currency.available * currency.denominationName)}</td>
                                            </tr>
                                        );
                                    })}

                                    <tr>
                                        <td width="50px"></td>
                                        <td style={{}}>TOTAL</td>
                                        <td className="cTotal">{cFormat(this.getTotal.bind(this, "available")())}</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                        <div className="cBox" style={{ float: "left" }} ref="cashInDiv">
                            <p className="cLabel">Cash In <i className="fa fa-arrow-down cArrow"></i></p>
                            <table className="cTable" ref="tableIn">
                                <tbody>
                                    {this.state.currencyData.map((currency, i) => {
                                        return (
                                            <tr key={i}>
                                                <td>
                                                    <span style={{ background: "#c18fb7" }} className="cCurrency">{currency.denominationName > 500 ? currency.denominationName.toString()[0] + "K" : currency.denominationName}</span>
                                                </td>
                                                <td>
                                                    <input type="text" className="cInput" value={currency.in > 0 ? currency.in : ""} onChange={this.calculateIn.bind(this, currency, i)} disabled={currency.out > 0 ? true : false} />
                                                </td>
                                                <td className="rCurrency">{cFormat(currency.in * currency.denominationName)}</td>
                                            </tr>
                                        );
                                    })}
                                    <tr>
                                        <td width="50px"></td>
                                        <td style={{}}>TOTAL</td>
                                        <td className="cTotal">{cFormat(this.getTotal.bind(this, "in")())}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="cBox" style={{ float: "right", borderRight: "none" }} ref="cashOutDiv">
                            <p className="cLabel">Cash Out <i className="fa fa-arrow-up cArrow"></i></p>
                            <table className="cTable" ref="tableOut">
                                <tbody>
                                    {this.state.currencyData.map((currency, i) => {
                                        return (
                                            <tr key={i}>
                                                <td>
                                                    <span style={{ background: "#c18fb7" }} className="cCurrency">{currency.denominationName > 500 ? currency.denominationName.toString()[0] + "K" : currency.denominationName}</span>
                                                </td>
                                                <td>
                                                    <input type="text" className="cInput" value={currency.out > 0 ? currency.out : ""} disabled={currency.in > 0 ? true : false} onChange={this.calculateOut.bind(this, currency, i)} />
                                                </td>
                                                <td className="rCurrency">{cFormat(currency.out * currency.denominationName)}</td>
                                            </tr>
                                        );
                                    })}
                                    <tr>
                                        <td width="50px"></td>
                                        <td style={{}}>TOTAL</td>
                                        <td className="cTotal">{cFormat(this.getTotal.bind(this, "out")())}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>


                        <div style={{ clear: "both" }}></div>


                        <button
                            onClick={this.onSaveClick.bind(this)}
                            className="btn btnOk btnRight" style={{ marginRight: "25px" }}>
                            Save</button>
                        <button
                            onClick={this.onCancel.bind(this)}
                            className="btn btnOk btnRight" style={{ marginRight: "25px" }}>
                            Cancel</button>

                    </div>
                    : null
                }

                {this.state.showSpinner ? <Spinner></Spinner> : null}



            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/jsx/components/fragments/currency-entry.jsx